<span [dir]="options.dir!">
  <mat-sidenav-container [class]="'mainWrapper ' + options.activeTheme + ' ' + options.theme + '-theme transition-all duration-300'" autosize autoFocus [dir]="options.dir">
    <!-- ============================================================== -->
    <!-- Vertical Sidebar -->
    <!-- ============================================================== -->

    <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="!isOver"
      (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" 
      (mouseenter)="onSidebarMouseEnter()" 
      (mouseleave)="onSidebarMouseLeave()"
      [style.width.px]="options.sidenavCollapsed && !isHovering && !isOver ? 85 : 285"
      [ngClass]="{
        'sidebarNav transition-all duration-300 ease-in-out': true,
        'shadow-2xl z-[100]': isHovering
      }">
      <div class="flex flex-col h-full min-h-0 bg-white dark:bg-gray-900 overflow-hidden">
        <!-- Sidebar moderno integrado -->
        <app-sidebar class="flex flex-col flex-1 overflow-hidden min-h-0"
          (toggleMobileNav)="sidenav.toggle()" 
          (toggleCollapsed)="toggleSidebarCollapse()" 
          [showToggle]="isOver" 
          [isCollapsed]="options.sidenavCollapsed && !isHovering">
        </app-sidebar>
      </div>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="contentWrapper transition-all duration-300" #content>

      <app-header [showToggle]="!isOver" [toggleChecked]="options.sidenavCollapsed" (toggleCollapsed)="toggleSidebarCollapse()" (toggleMobileNav)="sidenav.toggle()"
        (toggleMobileFilterNav)="toggleFilterNav()" (optionsChange)="receiveOptions($event)"></app-header>

      <main class="pageWrapper" [ngClass]="{
          maxWidth: options.boxed
        }">

        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
      </main>

      <footer class="text-center text-muted pt-2.5 pb-6">
        <!-- Design and Developed by
        <a class="text-primary underline" href="https://tailwind-admin.com/"
          target="_blank">tailwind-admin.com</a> -->
      </footer>

    </mat-sidenav-content>

  </mat-sidenav-container>
</span>
